module.exports = __webpack_public_path__ + "media/images/pic/brodno/teddy_logo-c531d63d932192ebf1fd11a6a339d665.svg";